// App metadata client → webwalker-core (version).
// Paths/verbs are locked by tests/unit/coreContract*; do not change without updating contracts.

import Api from "@/api/Api";

export default {

  getVersion() {
    return Api().get("/version");
  },

};
